import { useEffect, useState } from "react";
import { _CompetitionType, _Entailment, _MacroProcess, _single, _SubMacroProcess } from "../../../../core/services/dataBean/EntityCatalog";

import { Singleton } from "../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable } from "../../../theme/Component/BasicTable";
import { Modal } from "../../../theme/Component/Modal";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { PrintObjectJson } from "../../../theme/Component/PrintObjectJson";
import { _AddKpiEmployee, _KpiMeasurementCatalog } from "../../../../core/services/dataBean/EntityCatalogVdos";
import usePaginator from "../../../theme/Component/usePaginator";
import { InputDate } from "../../../theme/Input/InputDate";
import { BasicButton } from "../../../theme/Component/BasicButton";
import { AccountEditor } from "../../../editor/AccountEditor";
import { SelectFunctionalID } from "../../../admin/configuracion/functionalID/SelectFunctionalID";
import { ProjectSelectEditor } from "../../../RemoteAbstractAction/editors/ProjectSelectEditor";
import { SelectBusinessCore } from "../../../erp/cellEditor/BusinessCore/SelectBusinessCore";
import { InputMoney } from "../../../theme/Input/InputMoney";

interface Props {
    idKpiMeasurement: number;
    KpiLevel?: any;
    KpiLevelName?: any;
    MeasurementTypeName?: any;
    NameFather?: any
}

export const KpiEmployee = ({ idKpiMeasurement, KpiLevel, KpiLevelName, MeasurementTypeName, NameFather }: Props) => {

    const kpimeasurement = useDataBean(_KpiMeasurementCatalog);
    const addkpimeasurement = useDataBean(_AddKpiEmployee);
    const single = Singleton.getInstance();
    const [Account, setAccount] = useState<any>(null);
    const [idLnFunctionalID, setidLnFunctionalID] = useState<any>(null);
    const [lista, setLista] = useState<any>([]);
    const [modalconsult, setModalconsult] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const paginador = usePaginator();

    useEffect(() => {
        getLista();
    }, [idKpiMeasurement, paginador.page])

    const getLista = () => {

        kpimeasurement.instance.getKpiEmployeeMeasurementCatalog(idKpiMeasurement, Account, idLnFunctionalID, paginador.page, 15).then(
            (resp: any) => {
                if (resp) {
                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * 15);
                    paginador.setRegiPerPage(15);
                    let x = resp.List;
                    x.forEach((user) => {
                        user.DataBeanProperties.idln = (user.DataBeanProperties.FunctionalIDJsonCode ?? "") + "-" + (user.DataBeanProperties.FunctionalIDName ?? "");

                    });
                    setLista(x)
                }
            }
        )

    }


    const deleteItem = () => {
        kpimeasurement.instance.deleteKpiEmployeeMeasurement(kpimeasurement.bean.IDKpiEmployeeMeasurement).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const addKpiEmployeeMeasurement = () => {

        addkpimeasurement.instance.addKpiEmployeeMeasurement(idKpiMeasurement, addkpimeasurement.bean.IDAccount, addkpimeasurement.bean.IDLnFunctionalID, addkpimeasurement.bean.Value, addkpimeasurement.bean.IDProject, addkpimeasurement.bean.IDBusinessCore, _single.getAccountID()).then(
            (resp: any) => {
                console.log(resp)
                setModal({ ...modal, "view": false });
                toast.success("Se realizo la Acción");
                getLista();
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const create = () => {
        setModal({ ...modal, "view": true });
    }
    const head = [
        { title: 'ID Medición', property: 'IDKpiEmployeeMeasurement', visible: true },
        { title: 'Empleado', property: 'AccountName', visible: true },
        { title: 'Area Funcional', property: 'idln', visible: true },
        { title: 'Valor Kpi', property: 'KpiValue', visible: true },
        { title: 'Actualizado por', property: 'EmployeeName', visible: true },
        { title: 'Fecha Actualización', property: 'Since', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]

    const listaBotones = () => {
        const botones = [
            // { titulo: 'Agregar Medición de KPI', icono: 'ri-delete-bin-line', visible: single.canDelete() && kpimeasurement.bean.Type !== 5, evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar Medición', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }


    return (
        <div className="row">
            <div className="row">
                <div className="col-md-4">
                    <div className="row">
                        <div className="col-md-6">
                            <strong style={{ color: "#024A86" }}>Nivel de Indicador</strong>
                        </div>
                        <div className="col-md-6">
                            <PrintJson json={KpiLevelName} />
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="row">
                        <div className="col-md-6">
                            <strong style={{ color: "#024A86" }}>Frecuencia Muestra</strong>
                        </div>
                        <div className="col-md-6">
                            <PrintJson json={MeasurementTypeName} />
                        </div>
                    </div>
                </div>
                <div className="col-md-4">
                    <div className="row">
                        <div className="col-md-6">
                            <strong style={{ color: "#024A86" }}>Nombre</strong>
                        </div>
                        <div className="col-md-6">
                            <PrintJson json={NameFather} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-6">
                    <AccountEditor idAccount={Account} onChange={(e) => { setAccount(e.IDAccount) }} label="Empleado" />
                </div>
                <div className="col-md-6">
                    <SelectFunctionalID label='Area Organizacional' functionalIDLn={idLnFunctionalID} onChange={(e: any) => { setidLnFunctionalID(e.IDLn) }} />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-add-circle-line" clase="primary" eventClick={getLista}>
                        Buscar
                    </BasicButton>
                </div>
            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={kpimeasurement.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>
            </div>
            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} eventModal={addKpiEmployeeMeasurement}>
                    <div className="row">

                        {KpiLevel === 12 && (

                            <div className="col-md-12">
                                <SelectFunctionalID label='Area Organizacional' functionalIDLn={addkpimeasurement.bean.IDLnFunctionalID} onChange={(e: any) => { addkpimeasurement.setBean({ ...addkpimeasurement.bean, "IDLnFunctionalID": e.IDLn }) }} />
                            </div>

                        )}
                        {KpiLevel === 13 && (

                            <div className="col-md-12">
                                <AccountEditor idAccount={addkpimeasurement.bean.IDAccount} onChange={(e) => { addkpimeasurement.setBean({ ...addkpimeasurement.bean, "IDAccount": e.IDAccount }) }} label="Empleado" />
                            </div>

                        )}
                        {KpiLevel === 14 && (

                            <div className="col-md-12">
                                <ProjectSelectEditor render={addkpimeasurement.bean.ProjectName} idSelector={addkpimeasurement.bean.IDProject} onChange={(e) => { addkpimeasurement.setBean({ ...addkpimeasurement.bean, "IDProject": e.IDProject, "ProjectName": e.Name }) }} returnType="Object" />
                            </div>

                        )}
                        {KpiLevel === 15 && (

                            <div className="col-md-12">
                                <SelectBusinessCore label='Unidad de Negocio' returnType="Object" idSelector={addkpimeasurement.bean.IDBusinessCore} onChange={(e) => { addkpimeasurement.setBean({ ...addkpimeasurement.bean, "IDBusinessCore": e.IDBusinessCore }) }} />
                            </div>

                        )}
                        <div className="col-md-12">
                            <InputMoney _label="Valor Kpi" _value={addkpimeasurement.bean.Value} onChange={(e) => { addkpimeasurement.setBean({ ...addkpimeasurement.bean, "Value": e }) }} />
                        </div>
                    </div>
                </Modal>
            </div>
            <div className="col-md-12">
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}